import React, { Component } from 'react';

import './App.css';
import NavBar from './container/NavBar'
import logo from './OlEze.gif'
import Footer from './container/Footer'

import Home from './container/Pages/Home'
import Soon from './container/Pages/Soon'
import About from './container/Pages/About'

import Confirm from './components/Confirm'
import LogIn from './components/LogIn'
import Register from './components/Register'
import PasswordRequest from './components/PasswordRequest'
import PasswordReset from './components/PasswordReset'
import Privacy from './container/Pages/Policies/PrivacyPolicy'
import Agreement from './container/Pages/Policies/SiteAgreement'
import {BrowserRouter as Router,  Route, NavLink } from 'react-router-dom'
import API from './utilities/API'
import Games from './components/GamesPage'
import Sweeper from './components/Games/Sweeper/Sweeper'
import Voidcheddar3rddoz from './components/Games/VoidCheddar/Voidcheddar3rddoz'
import Profile from './components/UserEdit'
//'./components/Games/Sweeper/Sweeper'
class App extends Component {
  constructor(props) {
    super(props);
    
    this.setUser = this.setUser.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleLogIn = this.handleLogIn.bind(this);
    //this.handleLogIn = this.handleLogIn.bind(this);
    //this.handleLogIn = this.handleLogIn.bind(this);
    //this.LogInClick = this.LogInClick.bind(this);
    let defaultOpts = [<NavLink className="dropdown-item" to="/login">Sign In</NavLink>,
                         <NavLink className="dropdown-item mr-auto" to="/register">Register</NavLink>];

  
    this.state =
      { 
        opts:defaultOpts.slice(),       
        logo: logo,
        usr:false,
        accountName: 'Account',
        setUser: this.setUser,
       };

         
      }
     
      componentDidMout(){
       // API.getUser(this.mountUser)        
      };
      mountUser(usr)
      {
       // console.log('Mount USR:' + usr);
        //this.setUser(this.state.usr);
      }
      
      handleLogIn = () => {
        
        
        
       }

       handleLogout(e){
         e.preventDefault();
         API.Logout();  
         this.setUser({usr:false,
           accountName: 'Account'});
           this.Router.render("/");
    
       }
       

      setUser(usr){
        console.log('IN SET USER')
      let barOpts = [];
      
      barOpts.length=0;
      barOpts.push((<NavLink key='0' className="dropdown-item" to="/login" >Sign In</NavLink>));
      barOpts.push((<NavLink key='1' className="dropdown-item" to="/register">Register</NavLink>));
      barOpts.push((<NavLink key='2' className="dropdown-item" to="/" onClick={function(e){this.handleLogout(e)}}>Sign Out</NavLink>));
      barOpts.push((<NavLink key='3' className="dropdown-item" to="/admin">Admin</NavLink>));
      barOpts.push((<NavLink key='4' className="dropdown-item" to="/password/request">Change Password</NavLink>));
      barOpts.push((<NavLink key='5' className="dropdown-item" to="/profile/request">Change Profile</NavLink>));
      let opts = [];
      opts.length=0;
      let acct = "Account";  
        
        if(!usr.email){
          opts[0] = barOpts.slice(0);
          opts[1] = barOpts.slice(1);
          
          console.log('no usr');          
        }else{
          if (!usr.username){
            acct = 'Welcome ' + usr.email;
          }else{
            acct = 'Welcome ' + usr.username;
          }
          
          console.log('yes usr');
          opts[0] = barOpts.slice(2,3);
          if(usr.hasAdmin){
            opts[1] = barOpts.slice(3,4);
          }
        }
       opts[2] = barOpts.slice(5); 
       opts[3] = barOpts.slice(4,5);   
      
        this.setState({
          accountName: acct,
          usr:usr,
          opts:opts});
       //   this.props.history.push('/');
          
      
      }
      render() {
      
       
        return ( 
          
            <Router>
              <div >
                <NavBar setUser={this.setUser} data={this.state}/>
                <Route exact={true}  path="/" render = {() => <Home data={this.state}/> }/>
                <Route exact={true}  path="/soon" render = {() => <Soon data={this.state}/>}/>
                <Route exact={true}  path="/games" render = {() => <Games data={this.state}/>}/>
                <Route exact={true}  path="/games/sweeper" render = {() => <Sweeper data={this.state}/>}/>
                <Route exact={true}  path="/games/voidcheddar3rddoz" render = {() => <Voidcheddar3rddoz data={this.state}/>}/>
                <Route exact={true}  path="/about" render = {() => <About data={this.state}/>}/>
                <Route exact={true}  path="/privacy" render = {() => <Privacy data={this.state}/>}/>
                <Route exact={true}  path="/policy" render = {() => <Agreement data={this.state}/>}/>
                <Route exact={true}  path="/password/request" render = {() => <PasswordRequest data={this.state}/>}/>
                <Route exact={true}  path="/profile/request" render = {() => <Profile setUser={this.setUser} data={this.state}/>}/>
                
                <Route exact={true} path="/login" render = {() => <LogIn  LogIn= {this.handleLogIn} setUser={this.setUser}/>}/>
                <Route exact={true}  path="/confirm/:onboardin/:email" render={({match}) => <Confirm setUser={this.setUser} match={match} />} />
                <Route exact={true}  path="/password/reset/:onboardin/:email" render={({match}) => <PasswordReset setUser={this.setUser} match={match} />} />
                <Route exact={true} path="/register" component={Register}/>
                <Footer/>      
              </div>
          </Router> 
          
        ); 
        
      }
       
       }
         
  
 
  
    
    
   
  
  
  
    


export default App;



// WEBPACK FOOTER //
// ./src/App.js